import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface ISendApiUserCredentialsRequest {
  userId: number;
  username: string;
  password: string;
  notificationType: string;
  email: string;
  phoneNumber: string;
}

async function sendApiUserCredentials(data: ISendApiUserCredentialsRequest): Promise<any> {
  try {
    return (await axiosInstance.post("/User/SendApiUserCredentials", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useSendApiUserCredentials() {
  return useMutation<any, Error, ISendApiUserCredentialsRequest>((variables) =>
    sendApiUserCredentials(variables)
  );
}
